import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

const LEGACY_PARAMS_TO_PARAMS = {
  from_n: 'from',
  to_n: 'to',
};

const PARAMS_TO_PARSE = ['from', 'to', 'from_c', 'to_c'];

const UNIT_MAP: Record<string, string> = {
  minute: 'm',
  minutes: 'm',
  hour: 'h',
  hours: 'h',
  day: 'd',
  days: 'd',
  week: 'w',
  weeks: 'w',
  month: 'M',
  months: 'M',
  year: 'y',
  years: 'y',
};

const UNIT_PATTERN = Object.keys(UNIT_MAP).join('|');
const LEGACY_RANGE_RE = new RegExp(`^Last_(\\d+)_(${UNIT_PATTERN})$`, 'i');

const parseLegacyValue = (value: string): string => {
  if (value.toLowerCase() === 'now') return 'now';

  const match = LEGACY_RANGE_RE.exec(value);
  if (match) return `now-${match[1]}${UNIT_MAP[match[2].toLowerCase()]}`;

  return value;
};

export const useLegacyQueryParamRedirect = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const next = new URLSearchParams(searchParams);

    Object.entries(LEGACY_PARAMS_TO_PARAMS).forEach(([key, value]) => {
      const legacyValue = searchParams.get(key);

      if (legacyValue && !next.has(value)) {
        next.set(value, legacyValue);
      }

      next.delete(key);
    });

    PARAMS_TO_PARSE.forEach((item) => {
      const rawValue = next.get(item);

      if (rawValue) {
        next.set(item, parseLegacyValue(rawValue));
      }
    });

    if (next.toString() !== searchParams.toString()) {
      setSearchParams(next, { replace: true });
    }
  }, [searchParams, setSearchParams]);
};
